
import { computed, defineComponent, PropType } from 'vue';
import CallToActionFullWidthLayout from '@/shared/content/blocks/call-to-action-layouts/CallToActionFullWidthLayout.vue';
import CallToActionHalfWidthLayout from '@/shared/content/blocks/call-to-action-layouts/CallToActionHalfWidthLayout.vue';
import CallToActionSpecialOfferLayout from '@/shared/content/blocks/call-to-action-layouts/CallToActionSpecialOfferLayout.vue';
import CallToActionLetsBeFriendsLayout from '@/shared/content/blocks/call-to-action-layouts/CallToActionLetsBeFriendsLayout.vue';
import CallToActionLookBookLayout from '@/shared/content/blocks/call-to-action-layouts/CallToActionLookBookLayout.vue';
import CallToAction7525Layout from '@/shared/content/blocks/call-to-action-layouts/CallToAction7525Layout.vue';
import CallToAction5050Layout from './call-to-action-layouts/CallToAction5050Layout.vue';
import CallToAction2575Layout from './call-to-action-layouts/CallToAction2575Layout.vue';
import CallToAction3In1Layout from './call-to-action-layouts/CallToAction3In1Layout.vue';
import { CallToActionTileModel, TileLayoutOption } from '@/types/B2BcontentServerContract';

export default defineComponent({
    name: 'CallToActionTile',
    components: {
        CallToActionFullWidthLayout,
        CallToActionSpecialOfferLayout,
        CallToActionLetsBeFriendsLayout,
        CallToActionLookBookLayout,
        CallToAction7525Layout,
        CallToAction5050Layout,
        CallToAction2575Layout,
        CallToActionHalfWidthLayout,
        CallToAction3In1Layout,
    },
    props: {
        content: {
            type: Object as PropType<CallToActionTileModel>,
            required: true,
        },
    },
    setup(props) {
        const layoutComponent = computed(() => {
            const defaultLayout = 'CallToActionFullWidthLayout';

            switch (props.content.layout) {
            case TileLayoutOption.FullWidth:
                return defaultLayout;
            case TileLayoutOption.Layout5050:
                return 'CallToAction5050Layout';
            case TileLayoutOption.Layout2575:
                return 'CallToAction2575Layout';
            case TileLayoutOption.Layout7525:
                return 'CallToAction7525Layout';
            case TileLayoutOption.LookBook:
                return 'CallToActionLookBookLayout';
            case TileLayoutOption.SpecialOffer:
                return 'CallToActionSpecialOfferLayout';
            case TileLayoutOption.LetsBeFriends:
                return 'CallToActionLetsBeFriendsLayout';
            case TileLayoutOption.HalfWidth:
                return 'CallToActionHalfWidthLayout';
            case TileLayoutOption.Layout3In1:
                return 'CallToAction3In1Layout';
            default:
                return defaultLayout;
            }
        });

        return {
            layoutComponent,
        };
    },
});
